export enum GA4ProductGuideSteps {
    Market = "productguide_Market",
    MachineTonnage = "productguide_MachineTonnage_Step",
    Product = "productguide_Product_Step",
    Optional = "productguide_Optional_Step",
    ContactUs = "productguide_Done_Step",
    Done = "productguide_Done",
  }